
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <span className="text-xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Houston Health Insurance
              </span>
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Connecting Houston residents with the top health insurance agencies specializing in private insurance, self-employed solutions, and cost-effective coverage for higher earners.
            </p>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-map-pin-line text-teal-500"></i>
              <span className="text-sm">11104 W Airport Blvd R D O, Stafford, TX 77477</span>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#top-agencies" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Top 10 Agencies
                </a>
              </li>
              <li>
                <a href="#why-choose" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:2812062619" className="text-gray-400 hover:text-teal-400 transition-colors text-sm flex items-center space-x-2 cursor-pointer">
                  <i className="ri-phone-line text-teal-500"></i>
                  <span>(281) 206-2619</span>
                </a>
              </li>
              <li className="text-gray-400 text-sm flex items-center space-x-2">
                <i className="ri-time-line text-teal-500"></i>
                <span>Mon-Fri: 9AM - 6PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Houston Health Insurance. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
